import type { AxiosResponse } from 'axios';
import getConfig from 'next/config';

import type { ILocationV2 } from '@sravni/types/lib/locations';
import { withCache } from '@sravni/ugc/lib/utils/cache';

import client from '../utils/client';

import LocationsClient from './client/LocationsClient';

const { apiGatewayUrl } = getConfig().publicRuntimeConfig;

export const findRegions = async (): Promise<AxiosResponse<ILocationV2[]>> => {
  const { data } = await client.get(`${apiGatewayUrl}/location/v2/locations/regions/`);

  return data;
};

export const findRegionalCenters = async (): Promise<AxiosResponse<ILocationV2[]>> => {
  const { data } = await client.get(`${apiGatewayUrl}/location/v2/locations/regional-centers/`);

  return data;
};

export const locationsSuggest = async (): Promise<AxiosResponse<ILocationV2[]>> => {
  const { data } = await client.get(`${apiGatewayUrl}/suggest/v2/locations/`);

  return data;
};

export const loadRegions = withCache(
  () => {
    return LocationsClient.get('/v2/locations', {
      params: {
        route: '*',
        limit: 1000000,
      },
    }).then(({ data }) =>
      data.reduce((ret, curr) => {
        ret[curr.garId] = curr;
        return ret;
      }, {}),
    );
  },
  { fnKey: 'regions' },
);

export const loadRegionalCenters = withCache(
  () => {
    return LocationsClient.get('/v2/locations/regional-centers').then(({ data }) =>
      data.reduce((ret, curr) => {
        ret[curr.garId] = curr;
        return ret;
      }, {}),
    );
  },
  { fnKey: 'regional-centers' },
);
